import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConfirmationComponent, ToastComponent } from '@web/shared/ui';
import { HttpLoadingComponent } from '@web/core';
import { isBrowserContext } from '@web/utils';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    ToastComponent,
    ConfirmationComponent,
    HttpLoadingComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  protected readonly isBrowserContext = isBrowserContext();
}
